import React from 'react';
import {Box, Stack, Typography} from '@mui/material';
import {StyleSx, Sx} from 'app/types/common';
import {Header} from 'app/components/FleetManager/Header';
import {TeamFilesWelcome} from 'app/components/features/files';
import {useCloud} from 'app/components/features/cloud';
import {TeamFiles} from 'app/components/widgets/files';
import {FeatureLockNotice} from 'app/components/entities/billing/base';
import {packSx} from 'app/util/packSx/packSx';

const rootStyles: StyleSx = {width: 1032, pl: 3, pr: 1.5, my: 2};

interface Props extends Sx {}

export function TeamFileManagement({sx}: Props) {
  const {team, user} = useCloud();
  const teamId = team.id;

  const permitEditBilling = user.role.canEditBilling();

  return (
    <Stack sx={sx} flex={1}>
      <Header searchValue="" showSearch={false} onSearch={() => {}} />

      <Stack flex={1} sx={rootStyles}>
        {team.caps.files.enabled ? (
          <TeamFiles sx={{flex: 1}} teamId={teamId} />
        ) : team.caps.files.reason === 'subscription_is_dq' ? (
          <LockNotice paymentAccess={permitEditBilling} />
        ) : (
          <TeamFilesWelcome permitEdit={permitEditBilling} />
        )}
      </Stack>
    </Stack>
  );
}

const bgSx: StyleSx = {
  backgroundImage:
    'image-set(url(/assets/img/background/files/bg.png) 1x, url(/assets/img/background/files/bg@2x.png) 2x), linear-gradient(250deg, #ADB5BD 8%, #FFFFFF 110%)',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 0px, center',
  backgroundSize: 'contain',
};

interface LockProps extends Sx {
  paymentAccess: boolean;
}

function LockNotice({sx, paymentAccess}: LockProps) {
  return (
    <FeatureLockNotice
      sx={packSx(bgSx, sx)}
      logo={
        <>
          <Box
            width={170}
            component="img"
            src="/assets/img/logo/edge/logo-dark.png"
            srcSet="/assets/img/logo/edge/logo-dark@2x.png 2x"
            alt="Epiphan File Management logo"
          />
          <Typography variant="body2" color="text.secondary">
            File Management
          </Typography>
        </>
      }
      title="Epiphan File Management disabled"
      description="The Epiphan Management page is currently disabled due to an unsuccessful payment. Please update your payment method to restore access."
      paymentAccess={paymentAccess}
    />
  );
}
